var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',{staticClass:"mb-2 dp--row"},[_c('div',{staticClass:"btn-box"},[_c('v-btn',{staticClass:"btn-sample-request",attrs:{"depressed":""},on:{"click":_vm.newSample}},[_vm._v("샘플 요청")])],1)]),_c('RealGrid',{ref:"grid",attrs:{"domName":_vm.grid,"settings":_vm.settings},on:{"changePage":_vm.loadData,"dbClick":_vm.dbClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }